import axios from "axios";
import {Storage} from "@/Services/Storage";

export default {
    name: 'payment-methods',
    state: {
        kazangDetails : null,
        paymentMethods : [],
        storeProductId: null,
    },
    getters: {
        getPaymentMethods : (state) => state.paymentMethods,
        getKazangDetails:(state)=> state.kazangDetails,
        getStoreProductId:(state)=> state.storeProductId
    },
    mutations: {
        setPaymentMethods : async (state , data) => {
            if (data){
                await Storage.setPaymentMethods(data);
            }else {
                data = await Storage.getPaymentMethods();
            }
            state.paymentMethods = data
        },
        setKazangDetails:(state , data)=> state.kazangDetails = data,
        setStoreProductId:(state , data)=> state.storeProductId = data
    },
    actions: {
        getAllPaymentMethods : async (context) => {
            let storeDB = await Storage.getCurrentStoreDB();
            if (!storeDB) return;
            return axios.get(franchiseTomcatApi + `payment_options/${storeDB}/getAll`)
                .then(({data}) => {
                    context.commit(`setPaymentMethods`,data)
                    return data;
                }).catch((err) => errorHandler.tomcatError(err))
        },
        updatePaymentMethod: async (context, payload) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let id = payload.id; // Extract the id from the payload
            // Remove the id from the payload to exclude it from the POST request body
            const { id: _, ...filteredPayload } = payload;

            // Add storeDB to the filtered payload
            filteredPayload.db = storeDB;

            return axios.post(`${DeliveryNote}api/payment_options/${id}`, filteredPayload)

                .catch((err) => errorHandler.tomcatError(err));
        },

        createPaymentMethod : async (context, payload) => {
            let storeDB = await Storage.getCurrentStoreDB();
            let user = await Storage.getCurrentUser();
            payload.user = user.Username;
            return axios.post(franchiseTomcatApi + `payment_options/${storeDB}`,payload)
                .catch((err) => errorHandler.tomcatError(err))
        },

        editPaymentMethod : async (context, data) => {
            let storeDB = await Storage.getCurrentStoreDB();
            return axios.put(franchiseTomcatApi + `payment_options/${storeDB}/${data.id}`, data)
                .catch((err) => errorHandler.tomcatError(err))
        },

        deactivatePaymentMethod : async (context, data) => {
            let storeDB = await Storage.getCurrentStoreDB();
            return axios.put(franchiseTomcatApi + `payment_options/${storeDB}/deactivate`, data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        /**
         * Fetch Kazang details for the current store
         * @param context
         * @returns {Promise<void>}
         */
        getKazangDetails : async (context) => {
            let storeDB = await Storage.getCurrentStoreDB();
            if (!storeDB) return;
            return axios.get(subscriptionTomcatApi + `customerUpdate/getKazangDetails/${storeDB}`)
                .then(({data})=>context.commit(`setKazangDetails`,data))
                // .catch((err) => errorHandler.tomcatError(err))
        },
        /**
         * Fetch the store's product ID to determine store type
         * productId: 1 = Lyt-Soft, 2 = Kazang POS, 3 = Lyt-ning
         * @param context
         * @returns {Promise<void>}
         */
        getStoreProductId : async (context) => {
            let store = await Storage.getCurrentStore();
            console.log('[getStoreProductId] Storage.getCurrentStore() returned:', store);
            if (!store) {
              console.log('[getStoreProductId] No store found');
              return;
            }
            console.log('[getStoreProductId] store.MainCustomerID:', store.MainCustomerID, '| store.mainCustomerID:', store.mainCustomerID);
            const mainCustomerID = store.MainCustomerID || store.mainCustomerID;
            if (!mainCustomerID) {
              console.log('[getStoreProductId] No mainCustomerID found in store');
              return;
            }

            const storeId = store.CustomerID || store.customerId;
            console.log('[getStoreProductId] Calling API for mainCustomerID:', mainCustomerID, 'storeId:', storeId);

            return axios.get(subscriptionTomcatApi + `license/customer/${mainCustomerID}`)
                .then(({data})=>{
                    console.log('[getStoreProductId] API response:', data);
                    // Find the matching store by comparing store IDs
                    const storeId = store.CustomerID || store.customerId;
                    const storeData = data.stores?.find(s => s.storeId === storeId || s.id === storeId);
                    console.log('[getStoreProductId] Looking for storeId:', storeId, 'found storeData:', storeData);
                    if (storeData) {
                        // Map subscriptionProduct to productId
                        const subscriptionProduct = storeData.subscriptionProduct;
                        let productId;
                        if (subscriptionProduct === 'Kazang POS') {
                            productId = 2;
                        } else if (subscriptionProduct === 'Lyt-Soft') {
                            productId = 1;
                        } else if (subscriptionProduct === 'Lyt-ning') {
                            productId = 3;
                        } else {
                            productId = null;
                        }
                        console.log('[getStoreProductId] Mapped productId:', productId);
                        context.commit('setStoreProductId', productId);
                    }
                })
                .catch((err) => {
                    console.error('Error fetching store productId:', err);
                });
        },
        /**
         * Update Kazang username and password for the current store
         * Uses global franchiseTomcatApi and injects storeDB into payload
         * @param context
         * @param payload {{username: string, password: string, channel?: string, id?: string|number, request_reference?: number}}
         * @returns {Promise<any>}
         */
        updateKazangDetails: async (context, payload) => {
            const storeDB = await Storage.getCurrentStoreDB();
            if (!storeDB) return;
            const body = {
                ...payload,
                storeDB: storeDB,
            };
            return axios.post(franchiseTomcatApi + `SetKazangUser/${storeDB}`, body)
                .then(({data}) => {
                    // Merge and persist into state for immediate UI feedback
                    const merged = { ...(context.state.kazangDetails || {}), ...payload };
                    context.commit('setKazangDetails', merged);
                    return data;
                })
                .catch((err) => errorHandler.tomcatError(err));
        },


    }
}
